import React, { useState } from "react";
import ChatBox from "./ChatBox";

const ChatBotWrapper = () => {
  const [visible, setVisible] = useState(false);

  return (
    <div style={{ position: "fixed", bottom: 20, right: 20, zIndex: 9999 }}>
      {visible ? (
        <div style={{ position: "relative" }}>
          <ChatBox />
          <button
            onClick={() => setVisible(false)}
            style={{
              position: "absolute",
              top: -10,
              right: -10,
              background: "#000",
              color: "#fff",
              border: "none",
              borderRadius: "50%",
              width: 24,
              height: 24,
              fontSize: 14,
              cursor: "pointer",
              boxShadow: "0 0 6px rgba(0,0,0,0.2)",
            }}
          >
            ✕
          </button>
        </div>
      ) : (
        <div style={{ textAlign: "center" }}>
          <button
            onClick={() => setVisible(true)}
            style={{
              background: "#000",
              border: "1px solid #444",
              borderRadius: "50%",
              width: 64,
              height: 64,
              padding: 10,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              boxShadow: "0 0 8px rgba(0,0,0,0.4)",
              cursor: "pointer",
              margin: "0 auto",
              flexDirection: "column",
              position: "relative",
              transition: "all 0.3s ease",
            }}
          >
            <div className="siri-bars">
              <div className="bar bar1"></div>
              <div className="bar bar2"></div>
              <div className="bar bar3"></div>
              <div className="bar bar4"></div>
              <div className="bar bar5"></div>
            </div>
          </button>
          <div style={{ fontSize: "11px", color: "#444", marginTop: 4 }}>
          Juno Assistant
          </div>
        </div>
      )}

      <style>{`
        .siri-bars {
          display: flex;
          align-items: end;
          height: 30px;
          gap: 3px;
          position: relative;
          z-index: 2;
        }

        .bar {
          width: 4px;
          background: #fff;
          animation: wave 1s infinite ease-in-out;
          border-radius: 2px;
        }

        .bar1 { animation-delay: 0s; }
        .bar2 { animation-delay: 0.1s; }
        .bar3 { animation-delay: 0.2s; }
        .bar4 { animation-delay: 0.3s; }
        .bar5 { animation-delay: 0.4s; }

        @keyframes wave {
          0%, 100% { height: 8px; }
          50% { height: 28px; }
        }
      `}</style>
    </div>
  );
};

export default ChatBotWrapper;